"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NormalizedNotarizationStatus = void 0;
/**
 * Provider-agnostic notarization status. Each underlying provider (Aven in-house notary,
 * ServiceLink, Personal Attorney) has its own status taxonomy; this enum is the normalized
 * projection used by callers that need a single set of states to switch over.
 */
var NormalizedNotarizationStatus;
(function (NormalizedNotarizationStatus) {
    NormalizedNotarizationStatus["notStarted"] = "notStarted";
    NormalizedNotarizationStatus["awaitingScheduling"] = "awaitingScheduling";
    // On-demand notary: waiting in line, paired with a notary, or inside the rejoin window
    NormalizedNotarizationStatus["inQueue"] = "inQueue";
    NormalizedNotarizationStatus["scheduled"] = "scheduled";
    NormalizedNotarizationStatus["inProgress"] = "inProgress";
    NormalizedNotarizationStatus["completed"] = "completed";
    NormalizedNotarizationStatus["failed"] = "failed";
    NormalizedNotarizationStatus["cancelled"] = "cancelled";
})(NormalizedNotarizationStatus || (exports.NormalizedNotarizationStatus = NormalizedNotarizationStatus = {}));
